import add from 'date-fns/add';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import endOfDay from 'date-fns/endOfDay';
import startOfDay from 'date-fns/startOfDay';
import sub from 'date-fns/sub';
import { LocalizedDate } from '@app/core/utilities/date.utilities';

const monthPattern = new RegExp(/^(0[1-9]|1[0-2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(\d{5,}|[2-9](?=\d*[1-9])\d{3})$/); // 'mm/dd/yyyy'
const dayPattern = new RegExp(/^(0[1-9]|[12][0-9]|3[01])(\/|-)(0[1-9]|1[0-2])(\/|-)(\d{5,}|[2-9](?=\d*[1-9])\d{3})$/); // 'dd/mm/yyyy'

export const FormatDateString = (value: string): string => {
  const splitValues = value.split('/');
  if (splitValues.length === 2 && +splitValues[0] < 10) {
    splitValues[0] = `0${+splitValues[0]}`;
  } else if (splitValues.length === 3) {
    if (+splitValues[1] < 10) {
      splitValues[1] = `0${+splitValues[1]}`;
    }
  }

  return splitValues.join('/');
};

export function IsUSADateFormat(format: string) {
  return format === 'MM/dd/yyyy';
}

export function DateValidationPattern(format: string) {
  return IsUSADateFormat(format) ? monthPattern : dayPattern;
}

export function GetDateErrorType(value: string, format: string): 'month' | 'year' | 'day' | 'default' {
  const splits = value.split('/');

  const monthFirst = IsUSADateFormat(format);
  const year = +splits[2];
  const day = +splits[monthFirst ? 1 : 0];
  const month = +splits[monthFirst ? 0 : 1];

  switch (true) {
    case month > 12:
      return 'month';
    case day > 31:
      return 'day';
    case year < 2000:
      return 'year';
    default:
      return 'default';
  }
}

export function FormatDateRange([start, end]: Date[]): string | null {
  try {
    if (!start || !end) return null;
    return LocalizedDate(start, 'd MMM yyyy') + ' - ' + LocalizedDate(end, 'd MMM yyyy');
  } catch (error) {
    return null;
  }
}

export function AddRemoveMonth(date: Date, months: number) {
  return add(date, { months });
}

export function GetPreviousDateRange(dates: [Date, Date] | null): [Date, Date] | null {
  if (!dates) {
    return null;
  }

  const res = [...dates];
  const days = differenceInCalendarDays(res[1], res[0]) + 1;
  if (!!days && !isNaN(days)) {
    return [startOfDay(sub(res[0], { days })), endOfDay(sub(res[0], { days: 1 }))];
  }

  return null;
}

export function GetPreviousYearDateRange(dates: [Date, Date] | null): [Date, Date] | null {
  if (!dates) return null;

  const res = [...dates];

  return [startOfDay(sub(res[0], { years: 1 })), endOfDay(sub(res[1], { years: 1 }))];
}
export function CheckDatesAreSame(dates1: [Date, Date], dates2: [Date, Date]): boolean {
  if (!dates1 || !dates2) return false;

  return +dates1[0] === +dates2[0] && +dates1[1] === +dates2[1];
}

export function GetDateRangeTillYesterday(date): [Date, Date] {
  return [date, sub(startOfDay(new Date()), { days: 1 })];
}
